import React from "react";
import URLRoutes from "./routes";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  return (
    <>
      <URLRoutes />
      <ToastContainer transition={Slide} />
    </>
  );
};

export default App;
